export enum PackageSelectionStrategy {
    PriorityBased = 'priority_based',
    Cheapest = 'cheapest',
}
